/**
 * @generated SignedSource<<9b18ee6d3c2a0f21f74ba6d441e290a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pontuacao_PointsQuery$variables = {
  slug: string;
};
export type pontuacao_PointsQuery$data = {
  readonly club: {
    readonly id: string;
    readonly ranking: {
      readonly events: ReadonlyArray<{
        readonly enabled: boolean;
        readonly event: string;
        readonly name: string;
        readonly points: number;
      }>;
    };
  };
};
export type pontuacao_PointsQuery = {
  response: pontuacao_PointsQuery$data;
  variables: pontuacao_PointsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Club",
    "kind": "LinkedField",
    "name": "club",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ClubRanking",
        "kind": "LinkedField",
        "name": "ranking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRankingEvent",
            "kind": "LinkedField",
            "name": "events",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "event",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "points",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pontuacao_PointsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pontuacao_PointsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6862fa6d82881aee216e09b77528ffc",
    "id": null,
    "metadata": {},
    "name": "pontuacao_PointsQuery",
    "operationKind": "query",
    "text": "query pontuacao_PointsQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    id\n    ranking {\n      events {\n        name\n        event\n        enabled\n        points\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e196ad245b5cc7d7aaeb1d0cf5de642d";

export default node;
